<template>
  <div>
    <van-nav-bar
      title="福利信息"
      left-text="返回"
      right-text=""
      @click-left="goHome"
    />
    <div class="user-header">
      <div class="user-info">
        <van-image
          round
          width="60"
          height="60"
          :src="userInfo.head_img_path ?userInfo.head_img_path : require('../../../public/static/user_headers.png')"
        />
        <div>{{ userInfo.user_name }}</div>
      </div>
    </div>

    <div class="font">
      <div
        class="font_one"
        style="text-align: center"
      >
        <div style="padding-left:6%">请扫码或添加</div>
        <div
          v-if="messag"
          style="font-size: 16px"
        >微信号：{{ messag.qq }}</div>
        <div>联系客服</div>
        <h2 style="color: red;font-weight: bolder;">领取专属优惠券！</h2>
      </div>
      <div class="font_two">
        <van-image
          width="120"
          height="120"
          :src="messag.wechat_img?imgDomain+messag.wechat_img:require('../../../public/static/ma.png')"
        />
       
      </div>
      

    </div>
    <div class="font_two">

        <van-image
          :src="imgDomain_share"
          mode="widthFix"
          style="width: 100%;"
        />
      </div>
  </div>
</template>

<script>
import { getUserInfo, get_customer } from '../../api.js'
import { post } from '../../request.js'
import { Toast, Loading, Icon, Image, NavBar } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [Image.name]: Image,
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL,
      userInfo: [],
      messag: [],
      imgDomain_share:
        process.env.VUE_APP_IMG_URL +
        '/app/static/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20210902141413_edited.jpg',
    }
  },

  mounted() {
    var that = this
    post(getUserInfo, {}).then((res) => {
      if (res.code == 200) {
        //  loading.clear();
        // 用户信息
        that.userInfo = res.data
      }
    })

    post(get_customer, {}).then((res) => {
      if (res.code == 200) {
        that.messag = res.data
      }
    })
  },

  methods: {
    //返回主页
    goHome() {
      this.$router.push({ path: '/' })
    },
  },
}
</script>

<style lang="less" scoped>
.user {
  &-info {
    padding-top: 40px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
  }
  &-header {
    height: 160px;
    background-image: url(/static/bc_img.png);
    background-size: 100% 100%;
  }
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}

.font {
  display: flex;
  background-color: #fff;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  font-size: 14px;
  border-radius: 8px;
  height: 40%;
  white-space: nowrap;
}

.font_one {
  padding-left: 10%;
  margin-top: 12%;
}

.font_two {
  padding-top: 2%;
  padding-right: 5%;
  padding-left: 5%;
  padding-bottom: 2%;
}

.center_one {
  background-color: #fff;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  border-radius: 8px;
}
.c_o_o {
  padding-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  padding-bottom: 5%;
  border-bottom: 2px solid #f4f6f8;
  border-bottom-width: 80%;
}
.c_o_t {
  display: flex;
  justify-content: space-between;
  padding-top: 5%;
  padding-left: 7%;
  padding-bottom: 7%;
}

.center_two {
  background-color: #fff;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  border-radius: 8px;
}
.c_t_o {
  padding-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  padding-bottom: 5%;
  border-bottom: 2px solid #f4f6f8;
  border-bottom-width: 80%;
}
.c_t_t {
  display: flex;
  justify-content: space-around;
  /*justify-content: space-between;*/
  padding-top: 5%;
  padding-left: 7%;
  padding-bottom: 7%;
}
.line {
  padding-top: 20%;
  white-space: nowrap;
  font-size: 14px;
  margin-left: -24%;
}
.bottom {
  display: flex;
  margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%;
  background-color: #fff;
  border-radius: 8px;
}
.b_o {
  padding-left: 8%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_t {
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_t:hover {
  color: red;
}

.b_tt {
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_f {
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
}

.b_f:hover {
  color: red;
}
</style>
